import { render } from "./POSSystemPage.vue?vue&type=template&id=17221636&ts=true"
import script from "./POSSystemPage.vue?vue&type=script&lang=ts"
export * from "./POSSystemPage.vue?vue&type=script&lang=ts"

import "./POSSystemPage.vue?vue&type=style&index=0&id=17221636&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__